<template>
  <div>
    <template v-if="items">
      <div class="text-xs-center py-5" v-if="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <template v-else-if="total > 0">
        <template v-for="(item, index) in items">
          <slot v-bind="{ item, index, size, total, pageNumber }"></slot>
        </template>
      </template>
      <div v-else class="pa-4 text-xs-center grey lighten-4 my-3" style="border-radius: 15px">
        No data
      </div>
      <div class="text-xs-center">
        <v-pagination :length="pageCount" v-model="pageNumber"></v-pagination>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['value', 'total', 'loading', 'size'],
  data() {
    return {
      pageNumber: 1,
      items: []
    }
  },
  computed: {
    pageCount() {
      let l = this.total || 0
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  mounted() {
    this.setupItems(this.value)
  },
  methods: {
    setupItems(val) {
      // eslint-disable-next-line no-undef
      let items = _.cloneDeep(val)
      if (!items) {
        // this.total = 0;
        return []
      }
      // this.total = items.length;
      this.items = items
      // this.changePage(items, this.pageNumber);
    },
    changePage(pageNumber) {
      // const start = (pageNumber - 1) * this.size;
      // const end = start + this.size;
      // this.items = items.slice(start, end);
      this.$emit('onChangePage', pageNumber)
    }
  },
  watch: {
    pageNumber(newVal, oldVal) {
      if (newVal != oldVal) this.changePage(newVal)
    },
    value(newVal, oldVal) {
      if (newVal != oldVal) {
        this.setupItems(newVal)
        // if (this.pageCount <= 1) this.pageNumber = 1
        // else if (this.pageCount < this.pageNumber) this.pageNumber = this.pageCount
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Pagination3.vue